export default __webpack_public_path__ + "static/media/ranking.6d891a55.svg";